import React, { Component } from 'react';
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import './css/homepage.css';
import Welcome from '../Components/Homepage/Welcome';
import ChangePassword from '../Components/Settings/ChangePassword';

class SettingsContainer extends Component {
    constructor(props) {
        super(props);

        let us = JSON.parse(localStorage.getItem('user'));
        let username = us.user.email;

        this.state = {
            username: username,
            apikey: us.user.api_key
        }

    }
    render() {
        return (
            <div>
                <Navbar history={this.props.history} username={this.state.username} />
                <div className="main-body">

                    <ChangePassword history={this.props.history} username={this.state.username} />

                </div>
            </div>
        )
    }
}

export default withAuth(SettingsContainer);